
export function HtmlCourse() {
    return (
        <main id="main" className="site-main" role="main">
		   <article id="post-76" className="post-76 page type-page status-publish hentry">
			  <div className="entry-content" id="htmlcontent">
				 <p data-adtags-visited="true"><strong>Topic 1: Web Programming Introduction</strong></p>
				 <ul>
					<li>Architecture of a website</li>
					<li>Different technologies in making the website</li>
					<li>Web Development Introduction</li>
				 </ul>
				 <p data-adtags-visited="true"><strong>Topic 2: HTML Introduction</strong></p>
				 <ul>
					<li>History of HTML</li>
					<li>HTML Tags</li>
					<li>
					   HTML Attributes
					   <ul>
						  <li>Core Attributes</li>
						  <li>Internationalization Attributes</li>
						  <li>Generic Attributes</li>
					   </ul>
					</li>
					<li>
					   HTML Element
					   <ul>
						  <li>Block Elements</li>
						  <li>Inline Elements</li>
						  <li>Grouping Elements</li>
					   </ul>
					</li>
					<li>HTML Comments</li>
				 </ul>
				 <p data-adtags-visited="true"><strong>Topic 3: HTML Headers</strong></p>
				 <ul>
					<li>Title</li>
					<li>Base</li>
					<li>Link</li>
					<li>Styles</li>
					<li>Script</li>
					<li>Meta</li>
				 </ul>
				 <p data-adtags-visited="true"><strong>Topic 4: HTML Basic Formatting Tags</strong></p>
				 <ul>
					<li>HTML Basic Tags</li>
					<li>HTML Formatting Tags</li>
					<li>HTML Phrase Tags</li>
					<li>HTML Color Coding</li>
				 </ul>
				 <p><strong>Topic 5: HTML Grouping</strong></p>
				 <ul>
					<li>Div and Span Tags for Grouping</li>
				 </ul>
				 <p><strong>Topic 6: HTML Style Sheet</strong></p>
				 <ul>
					<li>Inline Style Sheet</li>
					<li>Internal Style Sheet</li>
					<li>External Style Sheet</li>
				 </ul>
				 <p><strong>Topic 7: HTML Lists</strong></p>
				 <ul>
					<li>Unordered Lists</li>
					<li>Ordered Lists</li>
					<li>Definition list</li>
				 </ul>
				 <p><strong>Topic 8: HTML Images</strong></p>
				 <ul>
					<li>Image and Image Mapping</li>
					<li>Image Creation</li>
					<li>Image Attributes</li>
				 </ul>
				 <p><strong>Topic 9: HTML Links</strong></p>
				 <ul>
					<li>Hyperlink/ Text Links</li>
				 </ul>
				 <ul>
					<li>URL – Uniform Resource Locator</li>
					<li>URL Encoding</li>
					<li>Image Links</li>
					<li>Email Links</li>
				 </ul>
				 <p><strong>Topic 10: HTML Tables</strong></p>
				 <ul>
					<li>Table tags</li>
					<li>Design Grids</li>
					<li>Nested Tables.</li>
				 </ul>
				 <p><strong>Topic 11: HTML Frames</strong></p>
				 <ul>
					<li>HTML Frames</li>
					<li>IFrames</li>
				 </ul>
				 <p><strong>Topic 12: HTML Form</strong></p>
				 <ul>
					<li>HTML Forms</li>
					<li>Form Elements &amp; Attributes</li>
					<li>HTML Input Types</li>
					<li>Form Submit</li>
					<li>Form</li>
				 </ul>
				 <p><strong>Topic 13: HTML Miscellaneous</strong></p>
				 <ul>
					<li>HTML Meta Tag</li>
					<li>XHTML</li>
					<li>HTML Deprecated Tags &amp; Attributes</li>
				 </ul>
				 <p><strong>Topic 14: HTML Responsive Design</strong></p>
				 <ul>
					<li>HTML Layout</li>
					<li>HTML Responsive</li>
				 </ul>
			  </div>
		   </article>
		</main>
    )
}